import { useQuery } from '@tanstack/react-query'

import { getTransactionEvidenceEmailAddress } from '@src/api'
import { DefaultApiGetTransactionEvidenceEmailAddressRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchTransactionEvidenceEmailAddress = (
  params: DefaultApiGetTransactionEvidenceEmailAddressRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.userAccountId,
    queryFn: () => getTransactionEvidenceEmailAddress(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_TRANSACTION_EVIDENCE_EMAIL_ADDRESS,
      params.userAccountId,
    ],
  })
}
